var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { guid } from '@progress/kendo-react-common';
import { HeaderSelectionCell } from '@progress/kendo-react-data-tools';
var TreeListHeaderSelectionCell = /** @class */ (function (_super) {
    __extends(TreeListHeaderSelectionCell, _super);
    function TreeListHeaderSelectionCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inputId = guid();
        return _this;
    }
    /**
     * @hidden
     */
    TreeListHeaderSelectionCell.prototype.render = function () {
        return React.createElement(HeaderSelectionCell, __assign({ inputId: this._inputId }, this.props));
    };
    return TreeListHeaderSelectionCell;
}(React.Component));
export { TreeListHeaderSelectionCell };
//# sourceMappingURL=TreeListHeaderSelectionCell.js.map